module.exports = __webpack_public_path__ + "img/budget-expanse.766e3a92.svg";